import { once } from 'utils/utils';

const isWebPSupported = once(() =>{
	let elem = document.createElement('canvas');
	if (!!(elem.getContext && elem.getContext('2d'))) {
		// was able or not to get WebP representation
		return elem.toDataURL('image/webp').startsWith('data:image/webp');
	} 
});

export { isWebPSupported };